module.exports = __webpack_public_path__ + "static/media/logo_aws_graviton.c35ace31.png";